import standardisePrice from '../../../../../util/standardisePrice';
import {
  IHandleQuickSearchResult,
  ISearchProviderConfig,
  IQuickSearchResultCollection, IQuickSearchResultPage,
  ISearchAndFilterProduct, ISearchAndFilterProductImage, ISearchAndFilterProductPrice,
  IQuickSearchResultSuggestion,
  IQuickSearchResultArticle
} from '../../../types';
import BoostCommerceApi from '../api';


const HandleSearch = (searchTerm: string, config: ISearchProviderConfig): Promise<IHandleQuickSearchResult> => (new Promise<IHandleQuickSearchResult>((resolve) => {

  const response: IHandleQuickSearchResult = {
    raw: null,
    typos: [],
    products: [],
    collections: [],
    suggestions: [],
    pages: [],
    articles: [],
  }

  try {

    BoostCommerceApi(config.apiKey, config.apiEndpoint).request('search/suggest', {
      q: searchTerm,
      // eslint-disable-next-line camelcase
      suggestion_limit: config.qsSuggestionsLimit,
      // eslint-disable-next-line camelcase
      product_limit: config.qsProductsLimit,
      // eslint-disable-next-line camelcase
      collection_limit: config.qsCollectionLimit,
      // eslint-disable-next-line camelcase
      page_limit: config.qsPagesLimit,
    }).then((res) => {

      // Early resolve if we have no results
      if (typeof res.data === 'undefined' || res.data.all_empty === true) {
        resolve(response)
      }

      // Map collections
      response.collections = res.data.collections.map((collection) => {
        return <IQuickSearchResultCollection>{
          id: collection.id,
          title: collection.title,
          handle: collection.handle,
          url: `/collections/${collection.handle}`
        }
      })

      // Map products
      response.products = res.data.products.map((product) => {
        const priceMin = standardisePrice(product.price_min)
        const priceMax = standardisePrice(product.price_max)
        const originalPrice = product.compare_at_price_max ? standardisePrice(product.compare_at_price_max) : priceMax 

        return <ISearchAndFilterProduct>{
          id: product.id,
          name: product.title,
          url:  `http${window.location.port ? '' : 's'}://${location.hostname}${window.location.port ? ':' + window.location.port : ''}/products/${product.handle}`,
          images: product.images_info.map((image): ISearchAndFilterProductImage => {
            return<ISearchAndFilterProductImage>{
              src: image.src
            }
          }),
          price: <ISearchAndFilterProductPrice>{
            priceMin,
            priceMax,
            finalPrice: priceMax,
            originalPrice
          }
        }
      })

      // map suggestions
      response.suggestions = res.data.suggestions.map((suggestion) => {
        return <IQuickSearchResultSuggestion>{
          value: suggestion,
          query: suggestion.replace(/(<([^>]+)>)/gi, '').replace(/ /g, '+')
        }
      })

      /// map pages
      response.pages = res.data.pages.filter((page) => {
        return page.url.includes('/pages/')
      }).map((page) => {
        return <IQuickSearchResultPage>{
          id: page.id,
          handle: page.handle,
          title: page.title,
          url: page.url
        }
      })

      // map articles
      response.articles = res.data.pages.filter((page) => {
        return !page.url.includes('/pages/')
      }).map((page) => {
        return <IQuickSearchResultArticle>{
          id: page.id,
          handle: page.handle,
          title: page.title,
          url: page.url
        }
      })

      resolve(response)
    })
  } catch (e) {
    console.error(e)
    resolve(response)
  }
}))

export default HandleSearch